import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link } from "react-router-dom";
import "./PackageDetail.css"; 
import CloseIcon from '@mui/icons-material/Close';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WhyTrust from '../layout/WhyTrust';

export default function CheckOut() {
  return (
    <>
    <Header/>
      
     <div className="test_bredcum_sec">
             <div className="container-fluid">
                 <div className="test_bredcum">
                     <Link to="/">Home</Link>
                     <span>&gt;</span>
                     <span className='name_p'>CheckOut</span>
                 </div> 
             </div> 
         </div>

     <div className="checkout_main_pg">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-7">
                    <div className="check_out_price_box">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="main_price_boxc booking_box">
                                    <div className="text_icon-cot">
                                        <div>
                                            <h3>Thyroid Assessment - Basic</h3>
                                            <p>Thyroid Profile Total Blood</p> 
                                        </div> 
                                        <div>
                                            <CloseIcon/>
                                        </div>
                                    </div>
                                    <div class="price_and_offer check_out_offer"><h5>₹699 <span class="off_price_pakages">(₹999)</span></h5><span class="offer_pakages">25% Off</span></div>
                                    <p className='price_box_co_p'><WatchLaterOutlinedIcon/> Earliest reports within 10 hours</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                 <div className="main_price_boxc booking_box">
                                    <div className="text_icon-cot">
                                        <div>
                                            <h3>Thyroid Assessment - Basic</h3>
                                            <p>Thyroid Profile Total Blood</p> 
                                        </div> 
                                        <div>
                                            <CloseIcon/>
                                        </div>
                                    </div>
                                    <div class="price_and_offer check_out_offer"><h5>₹699 <span class="off_price_pakages">(₹999)</span></h5><span class="offer_pakages">25% Off</span></div>
                                    <p className='price_box_co_p'><WatchLaterOutlinedIcon/> Earliest reports within 10 hours</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="patient-info_checkout booking_box">
                        <h3>Patient Information</h3>
                        <div className="patient-info_checkout-mian">

                            <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Name</span>
                                </div>
                                <h5>Manoj Deshmukh</h5>
                            </div>

                            <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <LocalPhoneIcon/>
                                    <span>Phone Number</span>
                                </div>
                                <h5>+91-9876541238</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Age</span>
                                </div>
                                <h5>30Yrs</h5>
                            </div>
                            
                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Gender</span>
                                </div>
                                <h5>Male</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <EmailOutlinedIcon/>
                                    <span>Email</span>
                                </div>
                                <h5>manoj@gmail.com</h5>
                            </div>

                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <LocationOnIcon/>
                                    <span>Plot No.</span>
                                </div>
                                <h5>15 Corner, Sector 10 Shopping Center</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <LocationOnIcon/>
                                    <span>State</span>
                                </div>
                                <h5>Rajasthan</h5>
                            </div>

                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <LocationOnIcon/>
                                    <span>City</span>
                                </div>
                                <h5>Jaipur</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <LocationOnIcon/>
                                    <span>Locality</span>
                                </div>
                                <h5>Vijay Path , Mansarovar</h5>
                            </div>

                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <LocationOnIcon/>
                                    <span>Pincode</span>
                                </div>
                                <h5>302020 </h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <CalendarMonthOutlinedIcon/>
                                    <span>Date</span>
                                </div>
                                <h5>April 31 2026</h5>
                            </div>

                             <div className="info_icon_patient withbackground">
                                <div className="icon_info_pat">
                                    <WatchLaterOutlinedIcon/>
                                    <span>Time</span>
                                </div>
                                <h5>07:00 AM</h5>
                            </div>

                             <div className="info_icon_patient">
                                <div className="icon_info_pat">
                                    <PersonIcon/>
                                    <span>Booking For</span>
                                </div>
                                <h5>Myself</h5>
                            </div> 
                            
                        </div>   
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="for_sticky_section">
                        <div className="summary_sec booking_box">
                            <h3>Summary</h3>
                            <div className="price_booking">
                                <div className="name_price_booking">
                                    <h4>Package Fees</h4>
                                    <h5>₹999</h5>
                                </div>
                                <div className="name_price_booking">
                                    <h4>Plateform Fees</h4>
                                    <h5>₹0</h5>
                                </div>
                                <div className="name_price_booking">
                                    <h4>GST (18%)</h4>
                                    <h5>₹152.43</h5>
                                </div> 
                            </div>
                            <div className="total_price_booking ">
                                <h4>Total Payable</h4>
                                <h5>₹ 1,151.643</h5>
                            </div>
                        </div>

                        <div className="policy-btn-box booking_box summary_sec">
                            <div className="icon_content_pb">
                                <VerifiedUserOutlinedIcon/>
                                <div>
                                    <h5>Your payment is Safe & Secure</h5>
                                    <p>Easy cancellation & 100% refund on eligible cancellations.</p>
                                </div>
                            </div>
                            <div className='police_btn_booking'><a href="#">View Policy <KeyboardArrowRightOutlinedIcon/></a></div> 
                        </div>

                        <div className="total_payble booking_box total_amount_cot">
                            <div className="text_payble">
                                <p>Total Amount</p>
                                <h5>₹ 1,151.64/-</h5>
                                <p>(Inclusive of all taxes)</p>
                            </div>
                            <div className="book_now_payble">
                                <Link to="/ThankYou">Pay Now <EastOutlinedIcon/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WhyTrust/>
     </div>


    <Footer/>
    </>
  )
}
